import request from '@/config/axios'

export interface BossCircleCompanyAccountVO {
  id?: string
  name: string
  creditCode?: string
  logo?: string
  ownerUserId?: string
  certId?: string
  status: number
  memberCount?: number
  createTime?: string
}

export const getCompanyAccountPage = (params: {
  pageNo: number
  pageSize: number
  name?: string
  status?: number
}) => request.get({ url: '/bosscircle/company/page', params })

export const updateCompanyAccountStatus = (id: string | number, status: number) =>
  request.put({
    url: '/bosscircle/company/update-status',
    params: { id, status }
  })
